/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Link} from 'react-router-dom'
import './components/styles/auth-revamp.scss'

const SLIDER_IMAGES = [
  '/media/auth/onboard-1.png',
  '/media/auth/onboard-5.png',
  '/media/auth/onboard-2.png',
  // '/media/auth/onboard-3.png',
  // '/media/auth/onboard-4.png',
]

const AuthLayout = () => {
  const [slideIndex, setSlideIndex] = useState(0)

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((i) => (i + 1) % SLIDER_IMAGES.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className='auth-revamp'>
      <div className='auth-revamp-body'>
        <div className='auth-revamp-bg' />
        <div className='auth-revamp-geo' />
        <div className='auth-revamp-shape' style={{top: '10%', left: '-120px'}} />
        <div
          className='auth-revamp-shape auth-revamp-shape--slow'
          style={{bottom: '5%', right: '-140px'}}
        />

        <div className='auth-revamp-card'>
          <div className='auth-revamp-left'>
            {SLIDER_IMAGES.map((src, i) => (
              <img
                key={src}
                src={src}
                alt=''
                className={`auth-revamp-slide ${i === slideIndex ? 'active' : ''}`}
              />
            ))}
            {/* <div
              style={{
                position: 'absolute',
                bottom: '2.5rem',
                left: '2.5rem',
                color: '#fff',
              }}
            >
              <h1 style={{fontSize: '1.875rem', fontWeight: 700}}>Capturing Moments,</h1>
              <p style={{fontSize: '1.125rem', opacity: 0.8}}>Creating Memories</p>
            </div> */}
            <div
              style={{
                position: 'absolute',
                bottom: '1rem',
                right: '1rem',
                display: 'flex',
                gap: '0.5rem',
              }}
            >
              {SLIDER_IMAGES.map((_, i) => (
                <button
                  key={i}
                  type='button'
                  onClick={() => setSlideIndex(i)}
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    background: i === slideIndex ? '#0000009E' : 'rgba(118, 118, 118, 0.27)',
                  }}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
            {/* <div style={{position: 'absolute', top: '1.5rem', left: '1.5rem'}}>
              <Link
                to='/'
                style={{
                  display: 'inline-block',
                  padding: '0.25rem 1rem',
                  fontSize: '0.875rem',
                  background: 'rgba(0,0,0,0.4)',
                  borderRadius: '0.5rem',
                  color: '#fff',
                  textDecoration: 'none',
                }}
              >
                ← Back to website
              </Link>
            </div> */}
          </div>

          <div className='auth-revamp-form-panel'>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
